module.exports = __webpack_public_path__ + "img/15-building-liveable-social.a6818e07.jpg";